<template>
  <div class="category-page-wrapper">
    <div class="category-dynamic-content flex-col">
      <PageSection
        v-for="(section, index) in sections"
        :key="`${index}-section`"
        :section="section"
        render-mode="clp"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { QueryTypes } from '~/server/utils/contentstack';
import { contentstackRequest } from '~/util/contentstack/api';
import { getFirstIndex } from '~/util/arrays';
import { metaGen } from '~/util/metadata';
import { useRootStore } from '~/store';
// import { DyPreOrganizedData } from '~/composables/dy-fetch';

const route = useRoute();
const rootStore = useRootStore();
const { locale } = useI18n();
const event = useRequestEvent();

// const categoryUrl = route?.params?.category;
const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const ctsData = await contentstackRequest(QueryTypes.clp, `/c/${route.params.category}`, {
    event,
    query: {
      locale: locale?.value,
    },
  });
  if (!ctsData) throw createError({ statusCode: 404, message: 'Page not found' });
  // console.log('CATEGORY cts data', ctsData)

  const categoryPage = getFirstIndex(ctsData?.data?.all_category_landing_page?.items);
  if (!categoryPage) throw createError({ statusCode: 404, message: 'Page not found' });

  // if (process.server) {
  //   const event = useRequestEvent();
  //   const title = categoryPage?.display_title || '';
  //   const data: DyPreOrganizedData = {
  //     pageType: 'CATEGORY',
  //     pageData: [title],
  //   };
  //   await dyChooseWithEvent(event, data);
  // }

  return {
    ctsData,
    categoryPage,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
});

useHead({
  ...(metaGen(rootStore?.brandSettings, {
    ...(asyncData.value?.categoryPage?.seo || {}),
  }) as any),
});

const state = reactive({
  categoryPage: asyncData.value?.categoryPage || ({} as any),
  ctsData: asyncData.value?.ctsData || ({} as any),
});

const sections = computed(() => {
  return state.categoryPage?.sections || [];
});

onMounted(() => {
  const { $bus }: any = useNuxtApp();
  $bus.emit('pageView', {
    url: document.URL,
    data: {
      category: [state.categoryPage?.display_title],
    },
  });
});
</script>
